class ConfiguratorAcuity extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.querySelector('configurator-drawer');
      this.form = this.querySelector('form');
      this.backButton = this.querySelector('button.drawer__back');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.submitButtonOriginalText = this.getSubmitButtonTextContent();
      this.footer = this.querySelector('.drawer__footer');
      this.framePrice = this.querySelector('.drawer__footer #FramePrice .price_container').dataset.amount / 100

      this.possibleNextSteps = ['form', 'appointment-location', 'extras'];
      this.nextStepsHtml = {};
      this.previousStepHtml = undefined;

      this.getNextSteps();
      this.getPreviousSteps();
      this.renderFooter();
      this.onChangeHandler();

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.form.addEventListener('change', this.onChangeHandler.bind(this));
    }
  
    getFormValue() {
      const formData = new FormData(this.form);
      return formData.get('acuity');
    }
  
    onChangeHandler() {
      const value = this.getFormValue();
      const submitButtonTextContainer = this.submitButton.querySelector('span.button_text');
      const submitButtonIconUse = this.submitButton.querySelector('.button_svg use');
      const iconHrefBase = submitButtonIconUse.attributes.href.value.split('icon-')[0];
      
  
      switch (value) {
        case 'account':
          if (this.submitButton.dataset.hasOwnProperty('customer')) {
            submitButtonTextContainer.textContent = 'Sehwerte übernehmen';
            submitButtonIconUse.attributes.href.value = iconHrefBase + 'icon-account'
          } else {
            submitButtonTextContainer.textContent = 'Weiter zur Anmeldung';
            submitButtonIconUse.attributes.href.value = iconHrefBase + 'icon-account'
          }
          break;
        case 'appointment':
          submitButtonTextContainer.textContent = 'Weiter zum Sehtest';
          submitButtonIconUse.attributes.href.value = iconHrefBase + 'icon-store'
          break;
        case 'input':
          submitButtonTextContainer.textContent = 'Sehwerte eingeben';
          submitButtonIconUse.attributes.href.value = iconHrefBase + 'icon-stacks'
          break;
        default:
          submitButtonTextContainer.textContent = this.submitButtonOriginalText;
          submitButtonIconUse.attributes.href.value = iconHrefBase + 'icon-eye_tracking'
          break;
      }
    }
  
    getRedirectLink() {
      const currentPath = window.location.pathname;
      const loginPath = '/customer_authentication/login?return_to=';
  
      return loginPath + currentPath;
    }
  
    getSubmitButtonTextContent() {
      return this.submitButton.querySelector('span.button_text').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
  
      const acuity = this.getFormValue();
  
      switch (acuity) {
        case 'account':
          if (this.submitButton.dataset.hasOwnProperty('customer')) {
            this.drawer.renderContents(this.nextStepsHtml['form']);
          } else {
            if (this.drawer.bundle) sessionStorage.setItem('glassesBundle', JSON.stringify(this.drawer.bundle));
            window.location.href = this.getRedirectLink();
          }
          break;
        case 'appointment':
          this.drawer.renderContents(this.nextStepsHtml['appointment-location']);
          break;
        case 'input':
          this.drawer.renderContents(this.nextStepsHtml['form']);
          break;
        case 'later':
          this.drawer.updateBundle('acuity', acuity);
          this.drawer.renderContents(this.nextStepsHtml['extras']);
          break;
        default:
          this.drawer.closest();
          break;
      }
    }
  
    getNextSteps() {
      const sections = [];
      this.possibleNextSteps.forEach((step) => sections.push('configurator-' + step));
      const url = '?sections=' + sections.join(',');
  
      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          this.possibleNextSteps.forEach((step) => {
            this.nextStepsHtml[step] = response[`configurator-${step}`];
          });
          this.submitButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    getPreviousSteps() {
      fetch('?sections=configurator-quality')
        .then((response) => response.json())
        .then((response) => {
          this.previousStepHtml = response['configurator-quality'];
          this.backButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    renderPreviousStep() {
      if (!this.previousStepHtml) return;
  
      this.drawer.renderContents(this.previousStepHtml);
    }
  
    renderNextStep(nextStep) {
      this.drawer.renderContents(this.nextStepsHtml[nextStep]);
    }

    renderFooter() {
      const chosenGlassTitle = this.drawer.bundle.glassVariant.title;
      const chosenGlassPrice = this.drawer.bundle.glassVariant.price / 100;

      const span = document.createElement('span');
      span.innerText = chosenGlassTitle;
      this.footer.querySelector('#chosenGlass').appendChild(span);
      this.footer.querySelector('#chosenGlass .price_container').innerText = chosenGlassPrice;
      this.footer.querySelector('#chosenGlass').removeAttribute('style');

      const totalPriceContainer = this.footer.querySelector('#configurator_subtotal .price_container');
      const framePrice = totalPriceContainer.dataset.amount / 100;
      const totalPrice = framePrice + chosenGlassPrice;

      totalPriceContainer.innerText = String(totalPrice.toFixed(2)).replace('.', ',');
      totalPriceContainer.dataset.amount = parseInt(totalPrice * 100);
    }
  }
  
  customElements.define('configurator-acuity', ConfiguratorAcuity);
  